import { useState } from 'react';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import BottomSheet from '@r1-frontend/ui-react/organisms/Modal/BottomSheet';
import StickyBottomSheet from '@r1-frontend/ui-react/organisms/Modal/StickyBottomSheet';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import SummaryInfo from '~/src/features/tariffBuilder/components/SummaryInfo';
import TotalInfo from '~/src/features/tariffBuilder/components/TotalInfo';
import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import getSummaryInfo from '~/src/features/tariffBuilder/selectors/getSummaryInfo';

import * as ST from './styled';

const SummaryInfoContainer = (): JSX.Element => {
    const [isBottomSheetShown, setIsBottomSheetShown] = useState(false);
    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);
    const summaryInfo = useCtxSelector(getSummaryInfo);


    const toggleStickyClick = () => {
        setIsBottomSheetShown(prev => !prev);
    };

    return (
        <>
            {isLaptop
                ? <>
                    <StickyBottomSheet onClick={toggleStickyClick}>
                        <TotalInfo
                            total={summaryInfo.total}
                            discountValue={summaryInfo.discountValue}
                        />
                    </StickyBottomSheet>
                    <BottomSheet onClose={toggleStickyClick} isShown={isBottomSheetShown}>
                        <SummaryInfo
                            {...summaryInfo}
                        />
                    </BottomSheet>
                </>
                : <WithSkeleton
                    height={350}
                    width={'100%'}
                    inline
                    containerClassName={'react-skeleton-flex-1 fd-row gap16'}
                    style={{
                        position: 'sticky',
                        top: 120,
                        marginTop: 54,
                        padding: 24,
                    }}
                >
                    <ST.RoundedStickyBlock>
                        <SummaryInfo
                            {...summaryInfo}
                        />
                    </ST.RoundedStickyBlock>
                </WithSkeleton>
            }
        </>
    );
};

export default SummaryInfoContainer;
